export const initialState = {
  listMoments: [],
  listFeaturedMoments: [],
};
  
export default {
  ...JSON.parse(JSON.stringify(initialState))
};
